import iFrameResize from 'iframe-resizer/js/iframeResizer';
export default {
  name: "PzUnnaxIframe",
  props: {
    url: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      height: '600px',
      width: '100%'
    };
  },
  methods: {
    onResize: function onResize(messageData) {
      this.height = messageData.height + 'px';
      this.width = messageData.width + 'px';
    },
    iframeLoaded: function iframeLoaded() {
      iFrameResize({
        log: false,
        checkOrigin: false,
        scrolling: 'no',
        onMessage: this.onMessage,
        // messageCallback está en desuso, debe usarse onMessage
        onResized: this.onResize // resizedCallback está en desuso, usar en su lugar onResize
      }, '#unnax');
    }
  }
};